import { CodebookModel } from 'app/shared/model/shared.model';
import * as yup from 'yup';
import { messages } from 'app/config/constants';

export interface RequestAdmissionFormModel {
  caseFunction: CodebookModel[];
  creatorTag: string;
  entryLetterDelivery: CodebookModel[];
  receiptDate: Date;
  requestAdmissionShortContent: string;
  actClassification: string;
  actOrderNumber: string;
  requestCompletionDate: Date;
  actCreationDate: Date;
  orgUnit: string;
  readonly: boolean;
}

export const requestAdmissionInitialData = {
  caseFunction: [],
  creatorTag: null,
  entryLetterDelivery: [],
  receiptDate: null,
  requestAdmissionShortContent: '',
  requestCompletionDate: null,
  actClassification: '',
  actOrderNumber: '',
  actCreationDate: null,
  orgUnit: '',
  readonly: false,
};

export const requestAdmissionSchema = yup.object().shape({
  caseFunction: yup.array().min(1, messages.MANDATORY_FIELD),
  creatorTag: yup.string().required(messages.MANDATORY_FIELD),
  entryLetterDelivery: yup.array().min(1, messages.MANDATORY_FIELD).required(messages.MANDATORY_FIELD),
  receiptDate: yup.string().required(messages.MANDATORY_FIELD),
});

export enum CaseFunctionEnum {
  SURJESAVATELJ = 1,
  RJESAVATELJ = 2,
  PISAR = 3,
  PODNOSITELJ = 4,
  PROCELNIK = 5,
  JAVNOPRAVNO_TIJELO = 6,
  ADMINISTRATOR_PREDMETA = 7,
}
